import React from 'react';
import PropTypes from 'prop-types';

const RowItem = ({ columnId, children }) => (
  <div className={`row-item column-${columnId}`}>
    <span className="row-item-text">
      {children}
    </span>
  </div>
);

RowItem.propTypes = {
  columnId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]),
};

export { RowItem };
